module.exports = __webpack_public_path__ + "img/coloredLogo_whiteText.6d3ad924.png";